"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicOffHover = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MicOffHover = function MicOffHover(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 18 20"
  }, props), /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "20",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.3971 17.4329L1.68808 1.72386L0.5 2.91194L6.13236 8.5443V9.24834C6.13236 10.0111 6.41104 10.6711 6.96841 11.2285C7.52578 11.7858 8.18582 12.0645 8.94854 12.0645C9.12455 12.0645 9.3299 12.0352 9.56458 11.9765L11.1047 13.5166C10.4006 13.8393 9.68192 14.0006 8.94854 14.0006C7.59912 14.0006 6.42571 13.5606 5.42832 12.6806C4.46025 11.7712 3.97622 10.6271 3.97622 9.24834H2.39212C2.39212 10.8324 2.93482 12.2259 4.02023 13.4286C5.13496 14.602 6.46971 15.3061 8.02448 15.5407V17.6822H5.19363V19.1842H12.7034V17.6822H9.8726V15.5407C10.8407 15.3941 11.6474 15.1154 12.2928 14.7047L16.209 18.6209L17.3971 17.4329Z",
    fill: "#37B7FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.13236 3.792L11.7647 9.38035V3.61598C11.7647 2.85327 11.486 2.19323 10.9287 1.63586C10.3713 1.07849 9.71126 0.799805 8.94854 0.799805C8.18582 0.799805 7.52578 1.07849 6.96841 1.63586C6.41104 2.19323 6.13236 2.85327 6.13236 3.61598V3.792Z",
    fill: "#37B7FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.6689 12.3285C15.2263 11.3605 15.505 10.3337 15.505 9.24834H13.9209C13.9209 9.92305 13.7888 10.5538 13.5248 11.1405L14.6689 12.3285Z",
    fill: "#37B7FF"
  })));
};
exports.MicOffHover = MicOffHover;